export default __webpack_public_path__ + "static/media/config_5.316a7cc2.png";